import * as React from 'react';

export const RRWheel = (props: React.SVGProps<SVGEllipseElement>) => (
	<ellipse id="RRWHEEL" stroke="#000" rx={24.24} ry={25.07} transform="matrix(0 1 1 0 389.907 370.205)" {...props} />
);
